import React, { useState, useEffect, useRef } from "react";

// material ui
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import { countAge } from "../validation";

import useStyles from "./styles";

import validation from "../validation";
import moment from "moment";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";

import InfoButton from "../../../../../components/InfoButton";

function SubFormRadio({
  id,
  setValue,
  saveValue,
  saveChangeValue,
  value,
  form,
  keluarga,
  no_kk,
  isSubmitting,
  pk,
  subformIndex,
  handleBackSub,
}) {
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const classes = useStyles();
  const [error, setError] = useState({});

  const [berlaku, setBerlaku] = useState(false);

  const [jawabanA, setJawabanA] = useState(value.jawabanA || "");
  const [jawabanB, setJawabanB] = useState(value.jawabanB || "");
  const [jawabanC, setJawabanC] = useState(value.jawabanC || "");
  const [jawabanD, setJawabanD] = useState(value.jawabanD || "");
  const [jawabanE, setJawabanE] = useState(value.jawabanE || "");

  const [hasKepalaKeluarga, setHasKepalaKeluarga] = useState(false);
  const [hasAnakDiBawahUmur, setHasAnakDiBawahUmur] = useState(false);

  useEffect(() => {
    const anggotaKeluarga = Object.values(keluarga);
    // console.log("Anggota Keluarga:", anggotaKeluarga);
    const isSuamiIstri =
      anggotaKeluarga &&
      anggotaKeluarga.length > 1 &&
      anggotaKeluarga[1].sts_hubungan === "2";
    const kepalaKeluarga = anggotaKeluarga.some(
      (member) =>
        member.sts_hubungan === "1" &&
        (member.sts_kawin === "1" ||
          member.sts_kawin === "2" ||
          member.sts_kawin === "3" ||
          member.sts_kawin === "4" ||
          member.sts_kawin === "5" ||
          member.sts_kawin === "6")
    );

    const cekChild = () => {
      const yearDiff = (tanggal) => {
        const dateA = moment();
        const dateB = moment(tanggal);
        const year = dateA.diff(dateB, "years", true);
        return parseInt(year);
      };
      let res = false;
      anggotaKeluarga.forEach((el) => {
        const dateParts = el.tgl_lahir.split("-");
        const tglLahir = new Date(
          +dateParts[2],
          +dateParts[1] - 1,
          +dateParts[0]
        );
        const age = yearDiff(tglLahir);
        if (
          (+el.sts_hubungan === 3 || +el.sts_hubungan === 4) &&
          +el.sts_kawin === 1 &&
          age <= 17
        ) {
          res = true;
        }
      });
      return res;
    };
    setHasKepalaKeluarga(isSuamiIstri);
    setHasAnakDiBawahUmur(cekChild());
    if (kepalaKeluarga && cekChild()) {
      setBerlaku(true);
    } else {
      setBerlaku(false);
      setJawabanE("3");
      setValue({ target: { name: "jawaban", value: "3" } });
    }
  }, [keluarga]);

  useEffect(() => {
    // console.log("masuk form pk 3");
    const handleKeluargaChange = (event) => {
      const updatedKeluarga = event.detail.keluarga;
      // console.log("Keluarga data changed (from event):", updatedKeluarga);
      const anggotaKeluarga = Object.values(updatedKeluarga);
      const kepalaKeluarga = anggotaKeluarga.some(
        (member) =>
          member.sts_hubungan === "1" &&
          (member.sts_kawin === "2" ||
            member.sts_kawin === "3" ||
            member.sts_kawin === "4" ||
            member.sts_kawin === "5" ||
            member.sts_kawin === "6")
      );

      const cekChild = () => {
        const yearDiff = (tanggal) => {
          const dateA = moment();
          const dateB = moment(tanggal);
          const year = dateA.diff(dateB, "years", true);
          return parseInt(year);
        };
        let res = false;
        anggotaKeluarga.forEach((el) => {
          const dateParts = el.tgl_lahir.split("-");
          const tglLahir = new Date(
            +dateParts[2],
            +dateParts[1] - 1,
            +dateParts[0]
          );
          const age = yearDiff(tglLahir);
          if (
            (+el.sts_hubungan === 3 || +el.sts_hubungan === 4) &&
            +el.sts_kawin === 1 &&
            age <= 17
          ) {
            res = true;
          }
        });
        return res;
      };

      // console.log("Kepala keluarga:", kepalaKeluarga);
      // console.log("Anak di bawah umur:", anak);

      setHasKepalaKeluarga(kepalaKeluarga);
      setHasAnakDiBawahUmur(cekChild());
      if (kepalaKeluarga && cekChild()) {
        setValue({ target: { name: "jawabanE", value: null } });
        // console.log("Setting berlaku = true");
        setBerlaku(true);
      } else {
        // console.log("Setting berlaku = false");
        setValue({ target: { name: "jawabanE", value: "3" } });
        setBerlaku(false);
      }
    };

    document.addEventListener("keluargaDataChanged", handleKeluargaChange);
    return () => {
      document.removeEventListener("keluargaDataChanged", handleKeluargaChange);
    };
  }, []);

  // useEffect(() => {
  //   console.log("Kondisi berlaku:", berlaku);
  // }, [berlaku]);
  // useEffect(() => {
  //   console.log("Checking kepala keluarga:", hasKepalaKeluarga);
  //   console.log("Checking anak di bawah umur:", hasAnakDiBawahUmur);
  // }, [hasKepalaKeluarga, hasAnakDiBawahUmur]);

  // useEffect(() => {
  //   const familyMembers = Object.values(keluarga);
  //   console.log("Family Members:", familyMembers);
  // }, []);

  useEffect(() => {
    setError({});
  }, []);

  // console.log("subformradio");

  // useEffect(() => {
  //   if (form.dependencies.length <= 0) {
  //     setBerlaku(true);
  //   } else {
  //     const valuesKel = Object.values(keluarga);
  //     const cekberlaku = form.dependencies.some((dep) => {
  //       return validation[dep](valuesKel);
  //     });

  //     if (!cekberlaku) {
  //       setValue({ target: { name: "jawaban", value: "3" } });
  //     }
  //     setBerlaku(cekberlaku);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [id, form]);

  const {
    pertanyaan,
    pertanyaanA,
    pertanyaanB,
    pertanyaanC,
    pertanyaanD,
    pertanyaanE,
    definisi_operasional,
    definisiOperasionalA,
    definisiOperasionalB,
    definisiOperasionalC,
    definisiOperasionalD,
    definisiOperasionalE,
  } = form;

  const handleChange = (e) => {
    if (e.target.type === "number") {
      if (parseInt(e.target.value) < 0) return false;

      // if (e.target.name === "kondisi" && ![0, 1].includes(parseInt(e.target.value))) {
      //     return false;
      // }
    }

    setValue(e);

    setError({
      ...error,
      [e.target.name]: "",
    });

    switch (e.target.name) {
      case "jawabanA":
        setJawabanA(e.target.value);
        break;
      case "jawabanB":
        setJawabanB(e.target.value);
        break;
      case "jawabanC":
        setJawabanC(e.target.value);
        break;
      case "jawabanD":
        setJawabanD(e.target.value);
        break;
      case "jawabanE":
        setJawabanE(e.target.value);
        break;
      default:
        break;
    }

    // setSomethingChange(true)
  };

  useEffect(() => {
    let normalizeValue = {
      Pertanyaan: pertanyaan,
      Jawab_Pilih: 0,
      Jawaban_H1: value.kondisi || 0,
      Jawaban_H2: 0,
      No_Pertanyaan: parseInt(form.no),
      Lainnya: value.jawaban_lainnya || "",
      answer: [
        {
          No_Jawaban: 1,
          pilihanpk: jawabanA,
        },
        {
          No_Jawaban: 2,
          pilihanpk: jawabanB,
        },
        {
          No_Jawaban: 3,
          pilihanpk: jawabanC,
        },
        {
          No_Jawaban: 4,
          pilihanpk: jawabanD,
        },
        {
          No_Jawaban: 5,
          pilihanpk: jawabanE,
        },
      ],
    };
    // console.log("Normalized value for saveChangeValue:", normalizeValue);
    // console.log("Current component state:", {
    //   jawabanA,
    //   jawabanB,
    //   jawabanC,
    //   jawabanD,
    //   jawabanE,
    //   value,
    // });
    if (value._rev) {
      normalizeValue._rev = value._rev;
    }
    saveChangeValue(normalizeValue);
  }, [jawabanA, jawabanB, jawabanC, jawabanD, jawabanE]);

  const validate = () => {
    let newError = {};

    // if (!value.jawaban) {
    //   newError.jawaban = "Wajib diisi";
    // }

    // Jika tidak berlaku, tidak perlu validasi semua jawaban
    // if (!berlaku) {
    //   // Hanya perlu pastikan jawaban sudah diset ke "tidak berlaku" (nilai 3)
    //   return newError;
    // }

    if (hasKepalaKeluarga) {
      if (value.jawabanB === "3") {
        newError.jawabanB = "Wajib diisi dengan Ya atau Tidak";
      }
    }
    if (!hasKepalaKeluarga) {
      if (value.jawabanB !== "3") {
        newError.jawabanB = "Wajib diisi dengan 'Tidak Berlaku'";
      }
    }
    if (berlaku) {
      if (value.jawabanE === "3") {
        newError.jawabanE = "Wajib diisi dengan Ya atau Tidak";
      }
    }
    if (!berlaku) {
      if (value.jawabanE !== "3") {
        newError.jawabanE = "Wajib diisi dengan 'Tidak Berlaku'";
      }

      if (!hasKepalaKeluarga && value.jawabanB !== "3") {
        newError.jawabanB = "Wajib diisi dengan 'Tidak Berlaku'";
      }

      if (!value.jawabanA) {
        newError.jawabanA = "Wajib diisi";
      }
      if (!value.jawabanB) {
        newError.jawabanB = "Wajib diisi";
      }

      if (!value.jawabanC) {
        newError.jawabanC = "Wajib diisi";
      }

      if (!value.jawabanD) {
        newError.jawabanD = "Wajib diisi";
      }

      return newError;
    }

    // Validasi hanya jika berlaku
    if (!value.jawabanA) {
      newError.jawabanA = "Wajib diisi";
    }

    if (!value.jawabanB) {
      newError.jawabanB = "Wajib diisi";
    }

    if (!value.jawabanC) {
      newError.jawabanC = "Wajib diisi";
    }

    if (!value.jawabanD) {
      newError.jawabanD = "Wajib diisi";
    }

    if (!value.jawabanE) {
      newError.jawabanE = "Wajib diisi";
    }

    return newError;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const findErrors = validate();

    const errorValues = Object.values(findErrors);

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      setError(findErrors);
    } else {
      let normalizeValue = {
        Pertanyaan: pertanyaan,
        Jawab_Pilih: 0,
        Jawaban_H1: value.kondisi || 0,
        Jawaban_H2: 0,
        No_Pertanyaan: parseInt(form.no),
        Lainnya: value.jawaban_lainnya || "",
        answer: [
          {
            No_Jawaban: 1,
            pilihanpk: value.jawabanA,
          },
          {
            No_Jawaban: 2,
            pilihanpk: value.jawabanB,
          },
          {
            No_Jawaban: 3,
            pilihanpk: value.jawabanC,
          },
          {
            No_Jawaban: 4,
            pilihanpk: value.jawabanD,
          },
          {
            No_Jawaban: 5,
            pilihanpk: value.jawabanE,
          },
        ],
      };
      // console.log("Submitting data:", normalizeValue);
      if (value._rev) {
        normalizeValue._rev = value._rev;
      }
      saveValue(normalizeValue);
    }
  };
  //console.log('here')
  return (
    <>
      <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <div className={classes.cardHeader}>
                <Typography margin="normal" paragraph>
                  <span className={classes.badge}>{form.no}</span>
                  <span dangerouslySetInnerHTML={{ __html: pertanyaan }}></span>
                </Typography>
              </div>
              <div style={{ position: "absolute", right: "0" }}>
                <InfoButton
                  title={`Pertanyaan ${form.no}`}
                  content={form.definisi_operasional}
                />
              </div>
            </Grid>
          </Grid>
          <div className={classes.cardBody}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography>{pertanyaanA} </Typography>

                <FormControl
                  error={error.jawabanA ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={value.jawabanA || ""}
                    onChange={handleChange}
                    aria-label="jawabanA"
                    name="jawabanA"
                    row
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="1"
                      label="Ya"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="2"
                      label="Tidak"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                  <FormHelperText>{error.jawabanA}</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography>{pertanyaanB} </Typography>
                <FormControl
                  error={error.jawabanB ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={value.jawabanB || ""}
                    onChange={handleChange}
                    aria-label="jawabanB"
                    name="jawabanB"
                    row
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="1"
                      label="Ya"
                      labelPlacement="end"
                      disabled={!hasKepalaKeluarga}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="2"
                      label="Tidak"
                      labelPlacement="end"
                      disabled={!hasKepalaKeluarga}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="3"
                      label="Tidak Berlaku"
                      labelPlacement="end"
                      disabled={hasKepalaKeluarga}
                    />
                  </RadioGroup>
                  <FormHelperText>{error.jawabanB}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography>{pertanyaanC} </Typography>
                <FormControl
                  error={error.jawabanC ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={value.jawabanC || ""}
                    onChange={handleChange}
                    aria-label="jawabanC"
                    name="jawabanC"
                    row
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="1"
                      label="Ya"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="2"
                      label="Tidak"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                  <FormHelperText>{error.jawabanC}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography>{pertanyaanD} </Typography>
                <FormControl
                  error={error.jawabanD ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={value.jawabanD || ""}
                    onChange={handleChange}
                    aria-label="jawabanD"
                    name="jawabanD"
                    row
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="1"
                      label="Ya"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="2"
                      label="Tidak"
                      labelPlacement="end"
                    />{" "}
                  </RadioGroup>
                  <FormHelperText>{error.jawabanD}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography>{pertanyaanE} </Typography>
                <FormControl
                  error={error.jawabanE ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={value.jawabanE || ""}
                    onChange={handleChange}
                    aria-label="jawabanE"
                    name="jawabanE"
                    row
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="1"
                      label="Ya"
                      labelPlacement="end"
                      disabled={!berlaku}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="2"
                      label="Tidak"
                      labelPlacement="end"
                      disabled={!berlaku}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="3"
                      label="Tidak Berlaku"
                      labelPlacement="end"
                      disabled={berlaku}
                    />
                  </RadioGroup>
                  <FormHelperText>{error.jawabanE}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>

      <Grid item xs style={{ marginTop: 20 }}>
        <Button
          ref={backRef}
          // disabled={!isSomethingChange || isSubmitting}
          onClick={handleBackSub}
        >
          <ChevronLeft className={classes.iconLeft} /> Sebelumnya{" "}
        </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
          style={{ float: "right" }}
          ref={nextRef}
          form={id}
          disabled={isSubmitting}
          type="submit"
        >
          {subformIndex >= 31 ||
          (subformIndex === 30 && pk["0231"] && pk["0231"].jawaban === "2")
            ? "Selanjutnya"
            : "Selanjutnya"}{" "}
          <ChevronRight className={classes.iconRight} />
        </Button>
      </Grid>
    </>
  );
}

export default SubFormRadio;
